import api from '@/services/api';
import { prepareQueryString } from './util';

const BASE_URL = '/shift';

export default {
  getShifts(params) {
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/?${query}`);
  },
  upsertShirt(payload) {
    return api.post(`${BASE_URL}/upsert`, payload);
  },
  getAvailableShifts(params) {
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/available?${query}`);
  },
  getAvailableShiftsByProvider(params) {
    const providerId = params.id;
    // eslint-disable-next-line no-param-reassign
    delete params.id;
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/available/${providerId}?${query}`);
  },
};
